// returns boolean TRUE or FALSE, based on item in local storage exists = true, does not = false
const hasLocalStorageCoordinates = (localStorageKey: string) => {
  return window.localStorage.getItem(localStorageKey) !== null;
};

export default hasLocalStorageCoordinates;
